import { confirmAccount } from "./confirm-account.service";

const confirmAccountService = { confirmAccount };

export default confirmAccountService;
